export default __webpack_public_path__ + "images/a36b608e09d9cafdc232f94fc7fc1dd2-language-icon--pt.svg";